import React from 'react';

import { BoatFooter } from '../../../_common/BoatFooter.tsx';

export type FooterProps = {
  // Empty
};

export const Footer: React.FC<FooterProps> = () => {
  return <BoatFooter waterSx={{ minHeight: { xs: 60, md: 100, lg: 0 } }} />;
};
